export default __webpack_public_path__ + "static/media/icon2.7166e94a.jpg";